import PayrollIntegrationPage from './PayrollIntegrationPage';
export default PayrollIntegrationPage;